import Service from '../AuthService';

const Corporation = {
  getAllCorporations() {
    // return Service.get(`corporations`);
    return Service.get(`corporation-platforms`);
  },
  getSettingCorporations() {
    return Service.get('settings/corporations')
  },
  getSettingCorporation(id) {
    return Service.get(`settings/corporations/${id}`)
  },
  createSettingCorporation(payload) {
    return Service.post('settings/corporations', payload)
  },
  editSettingCorporation(payload, id) {
    return Service.put(`settings/corporations/${id}`, payload)
  },
  deleteSettingCorporation(id) {
    return Service.delete(`settings/corporations/${id}`)
  },
  getCorporationAccounts() {
    return Service.get('settings/corporation-accounts')
  },
  getCorporationAccount(id) {
    return Service.get(`settings/corporation-accounts/${id}`)
  },
  createCorporationAccount(payload, token) {
    return Service.post(`settings/corporation-accounts?token=${token}`, payload)
  },
  updateCorporationAccount(payload, id, token) {
    return Service.put(`settings/corporation-accounts/${id}?token=${token}`, payload)
  },
  deleteCorporationAccount(id, token) {
    return Service.delete(`settings/corporation-accounts/${id}?token=${token}`)
  }
};

export default Corporation;
